module.exports = __webpack_public_path__ + "static/media/no-insight.e5ba58a5.png";